
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("c79DV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $8d1d9e5d3bd0c406$var$_jquery = $8d1d9e5d3bd0c406$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $8d1d9e5d3bd0c406$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $8d1d9e5d3bd0c406$var$init = module.exports.init = function init() {
    if ((0, $8d1d9e5d3bd0c406$var$_jquery["default"])(".ce_falfilebrowser_searchwords .searchwords a").length > 0) (0, $8d1d9e5d3bd0c406$var$_jquery["default"])(".ce_falfilebrowser_searchwords .searchwords a").on("click", function(e) {
        e.preventDefault();
        var target = (0, $8d1d9e5d3bd0c406$var$_jquery["default"])(this).attr("href");
        var value = (0, $8d1d9e5d3bd0c406$var$_jquery["default"])(this).attr("data-value");
        if (target && value) (0, $8d1d9e5d3bd0c406$var$_jquery["default"])(target).val(value);
        (0, $8d1d9e5d3bd0c406$var$_jquery["default"])(target).parents("form").submit();
        return false;
    });
};

});


//# sourceMappingURL=falfilebrowser.module.5e0232cd.js.map
